// @ts-nocheck
import { Dispatch } from 'react';
import { IAddEntityModalParameters } from '../models/AddEntityModalParameters';
import { ModalAction, ModalActions } from '../types/modal';
import { ModalTypes } from '../const/ModalTypes';

export const openProjectsModal = (
  modalParameters: IAddEntityModalParameters | null,
  onCreateEntity: (input: any) => void | null,
  onCreateEntities?: (input: any[]) => void | null,
  modalType: ModalTypes | null = null
) => {
  return async (dispatch: Dispatch<ModalAction>) => {
    try {
      dispatch({
        type: ModalActions.SET_MODAL_STATE,
        payload: {
          isModalOpen: true,
          modalType,
          modalParameters,
          onCreateEntity,
          onCreateEntities,
        },
      });
    } catch (e) {
      console.log(`ERROR: Can't open modal.`);
    }
  };
};

export const closeProjectsModal = () => {
  return async (dispatch: Dispatch<ModalAction>) => {
    try {
      dispatch({
        type: ModalActions.SET_MODAL_STATE,
        payload: {
          isModalOpen: false,
          modalType: null,
          modalParameters: null,
          onCreateEntity: null,
          onCreateEntities: null,
        },
      });
    } catch (e) {
      console.log(`ERROR: Can't close modal.`);
    }
  };
};
